import { Button, Grid, Stack } from '@mui/material'
import React from 'react'
import MainCard from 'ui-component/cards/MainCard'
import TextField from '@mui/material/TextField';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useState } from 'react';
import TopupCheckerTable from './Components/Topup Checker/TopupChecker';
import BackdropLoader from './Components/General/Loader';
import SnackBar from './Components/General/SnackBar';
import { useEffect } from 'react';
import { GetAllTopupRequest } from 'API/Limit_Topup_Checker/api';
import StatementStatus from './Components/Topup Checker/StatementStatus';
import FileUploadDialog from './Components/Topup Checker/FileUploadDialog';
import XLSX from 'sheetjs-style';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const formatDate = (date) => {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
};
//   comment added
const LimitTopupChecker = () => {
    const [ViewUploadStatementStatus, setViewUploadStatementStatus] = useState(false)

    const addLeadingZero = (num) => num < 10 ? `0${num}` : num;

    const [Data, setData] = useState({
        status: "P",
        fromdate: `${addLeadingZero(new Date().getDate())}/${addLeadingZero(new Date().getMonth() + 1)}/${new Date().getFullYear()}`,
        todate: `${addLeadingZero(new Date().getDate())}/${addLeadingZero(new Date().getMonth() + 1)}/${new Date().getFullYear()}`,
        usercode: "",
        bankname: "",
        ai_status:""
    })
    const [OpenFileUploadDialog, setOpenFileUploadDialog] = useState(false)


    const [IsLoading, setIsLoading] = useState(false)
    const [AlertMessage, setAlertMessage] = useState("")
    const [OpenAlert, setAlertOpen] = useState(false)
    const [AlertType, setAlertType] = useState("success")
    const [TopupData, setTopupData] = useState(null)


    const handleAlertOpen = (message, type) => {
        setAlertMessage(message)
        setAlertType(type)
        setAlertOpen(true)
    }

    const handleAlertClose = () => {
        setAlertOpen(false)
    }

    const handleFileUploadDialogOpen = () => {
        setOpenFileUploadDialog(true)
    }

    const handleFileUploadDialogClose = () => {
        setOpenFileUploadDialog(false)
    }

    const handleChange = (field, value) => {
        if (field === "todate" || field === "fromdate") {
            const [year, month, day] = value.split('-');
            const formattedDate = `${day}/${month}/${year}`;

            if (field === "todate") {
                if (new Date(Data.fromdate.split('/').reverse().join('-')) > new Date(value)) {
                    setData({ ...Data, [field]: formattedDate, "fromdate": formattedDate });
                } else {
                    setData({ ...Data, [field]: formattedDate });
                }
            } else {
                setData({ ...Data, [field]: formattedDate });
            }
        }
        else if (field === "usercode" && value.length <= 8) {
            if (/^[a-zA-Z0-9]*$/.test(value)) {
                setData({ ...Data, [field]: value.toUpperCase() })
            }
        }
        else if (field === "status") {

            setData({ ...Data, [field]: value })

        }
        else if (field !== "usercode") {
            if (/^[a-zA-Z0-9 -]*$/.test(value)) {
                setData({ ...Data, [field]: value })
            }

        }

    }



    const formatForInput = (dateStr) => {
        // Convert dd/MM/yyyy to yyyy-MM-dd
        const [day, month, year] = dateStr.split('/');
        return `${year}-${month}-${day}`;
    };

    const handleClear = () => {
        setData({
            status: "P",
            fromdate: `${addLeadingZero(new Date().getDate())}/${addLeadingZero(new Date().getMonth() + 1)}/${new Date().getFullYear()}`,
            todate: `${addLeadingZero(new Date().getDate())}/${addLeadingZero(new Date().getMonth() + 1)}/${new Date().getFullYear()}`
        })

        GetAllTopupRequest(setIsLoading, setTopupData, handleAlertOpen, {
            status: "P",
            fromdate: `${addLeadingZero(new Date().getDate())}/${addLeadingZero(new Date().getMonth() + 1)}/${new Date().getFullYear()}`,
            todate: `${(addLeadingZero(new Date().getDate()))}/${addLeadingZero(new Date().getMonth() + 1)}/${new Date().getFullYear()}`
        })


    }
    const handleSearch = () => {
        if (Data.usercode && Data.usercode !== "" && !/^[A-Z]{2}\d{6}$/.test(Data.usercode)) {
            handleAlertOpen("User Code is invalid", "error")
        }
        else {
            GetAllTopupRequest(setIsLoading, setTopupData, handleAlertOpen, Data)
        }
    }

    useEffect(() => {
        GetAllTopupRequest(setIsLoading, setTopupData, handleAlertOpen, Data)
    }, [Data.status])

    console.log("Data", IsLoading, TopupData);


    const downloadExcel = () => {
        setIsLoading(true);
        if (!TopupData) {
            handleAlertOpen("No data available to export", "error");
            setIsLoading(false);
            return;
        }

        // Flatten the objects
        const flattenObject = (obj) => {
            let result = {};
            for (const [key, value] of Object.entries(obj)) {
                const newKey = key;
                if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                    Object.assign(result, flattenObject(value, newKey));
                } else if (Array.isArray(value)) {
                    value.forEach((item, index) => {
                        Object.assign(result, flattenObject(item, `${newKey}_${index}`));
                    });
                } else {
                    result[newKey] = value;
                }
            }
            return result;
        };

        const flattenedData = TopupData?.map((row) => flattenObject(row));

        const desiredOrder = ['topupid', 'usercodewithname', 'statename', 'districtname', 'createddate', 'topupamount', 'topupmodeNM', 'ref1', 'ref2', 'benebank', 'instrumentdate', 'ai_status', 'status', 'reason', 'remarks'];

        // Reorder the flattened data
        const reorderedData = flattenedData.map((item) => {
            const reorderedItem = {};
            desiredOrder.forEach((key) => {
                if (Object.prototype.hasOwnProperty.call(item, key)) {
                    reorderedItem[key] = item[key];
                }
            });
            return reorderedItem;
        });

        // Define custom headers
        const headers = [
            'Request ID', 'Request From', 'State', 'District', 'Request Date', 'Topup Amount', 'Topup Type', 'Ref 1', 'Ref 2', 'Bank Name', 'Transfer Date', 'AI Status', 'Status', 'Reason', 'Remarks'
        ];

        // Add custom headers to the data
        const excelData = [desiredOrder.map(key => headers[desiredOrder.indexOf(key)])].concat(reorderedData.map(row => desiredOrder.map(key => row[key])));

        const worksheet = XLSX.utils.aoa_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Topup Data');

        XLSX.writeFile(workbook, 'Topup_report.xlsx');
        setIsLoading(false);
    };



    return (
        <Grid container>
            {
                ViewUploadStatementStatus ?
                    <StatementStatus setViewStatementStatus={setViewUploadStatementStatus} />
                    :
                    <Grid container>
                        <FileUploadDialog isLoading={IsLoading} setIsLoading={setIsLoading} handleAlertOpen={handleAlertOpen} open={OpenFileUploadDialog} handleClose={handleFileUploadDialogClose} />
                        <BackdropLoader open={IsLoading} />
                        <SnackBar open={OpenAlert} type={AlertType} message={AlertMessage} handleClose={handleAlertClose} />
                        <Grid item xs={12}>
                            <Accordion defaultExpanded>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    Search
                                </AccordionSummary>
                                <AccordionDetails>
                                <Grid container paddingInline={2} spacing={2} alignItems="center" justifyContent={"flex-satrt"}>
                                    <Grid item xl={2} lg={2} md={4} sm={6} xs={6}>
                                        <TextField
                                            id="outlined-basic"
                                            label="Ledger From Date"
                                            variant="outlined"
                                            value={Data && Data.fromdate ? formatForInput(Data.fromdate) : ""}
                                            type='date'
                                            onChange={(e) => handleChange("fromdate", e.target.value)}
                                            fullWidth
                                            InputLabelProps={
                                                {
                                                    shrink: true
                                                }
                                            }
                                            inputProps={
                                                {
                                                    max: Data.todate ? formatForInput(Data.todate) : new Date,
                                                    contentEditable: false,
                                                    // readOnly:true
                                                    onKeyDown: (e) => e.preventDefault(),

                                                    style: {
                                                        textAlign: 'left',
                                                        fontSize: '0.75rem', // Make text smaller
                                                        padding: '10px 15px', // Reduce padding
                                                    },

                                                }
                                            }
                                            sx={{
                                                '& input[type="date"]': {
                                                    pointerEvents: 'none', // Disable pointer events to prevent typing
                                                },
                                                '& input[type="date"]::-webkit-calendar-picker-indicator': {
                                                    cursor: 'pointer', // Ensure the calendar picker icon is clickable
                                                    pointerEvents: 'auto', // Re-enable pointer events for the calendar picker icon
                                                },

                                            }}
                                            size='small'
                                        />

                                    </Grid>

                                    <Grid item xl={2} lg={2} md={4} sm={6} xs={6}>
                                        <TextField
                                            id="outlined-basic"
                                            label="Ledger To"
                                            variant="outlined"
                                            value={Data.todate ? formatForInput(Data.todate) : ""}
                                            type="date"
                                            onChange={(e) => handleChange("todate", e.target.value)}
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            inputProps={{
                                                min: Data.fromdate ? formatForInput(Data.fromdate) : null,
                                                max: formatDate(new Date()),
                                                onKeyDown: (e) => e.preventDefault(),
                                                style: {
                                                    textAlign: 'left',
                                                    fontSize: '0.75rem', // Make text smaller
                                                    padding: '10px 15px', // Reduce padding
                                                },
                                            }}
                                            contentEditable={false}
                                            size="small"
                                            margin="dense" // Reduce margin

                                        />

                                    </Grid>

                                    <Grid item xl={2} lg={2} md={4} sm={6} xs={6}>
                                        <TextField
                                            id="outlined-basic"
                                            label="Agent Code"
                                            variant="outlined"
                                            value={Data.usercode ? Data.usercode : ""}
                                            onChange={(e) => handleChange("usercode", e.target.value)}
                                            fullWidth
                                            size='small'
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            inputProps={{
                                                style: {
                                                    textAlign: 'left',
                                                    fontSize: '0.75rem', // Make text smaller
                                                    padding: '10px 15px', // Reduce padding
                                                },
                                            }}

                                        />

                                    </Grid>


                                    <Grid item xl={2} lg={2} md={4} sm={6} xs={6}>
                                        <FormControl fullWidth size='small' margin="dense"
                                            style={{ fontSize: '0.875rem' }}>
                                            <InputLabel id="demo-simple-select-label">Beneficary bank</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={Data.bankname ? Data.bankname : "Select"}
                                                label="Beneficary bank"
                                                onChange={(e) => handleChange("bankname", e.target.value)}
                                                size='small'
                                                inputProps={
                                                    {
                                                        style: {
                                                            textAlign: 'left',
                                                            fontSize: '0.75rem', // Make text smaller
                                                            padding: '10px 15px',
                                                        },
                                                    }
                                                }
                                                sx={{
                                                    '.MuiInputLabel-outlined': {
                                                        transform: 'translate(12px, 14px) scale(1) !important',
                                                    },
                                                    '.MuiInputLabel-outlined.MuiInputLabel-shrink': {
                                                        transform: 'translate(12px, -6px) scale(0.75) !important',
                                                    },
                                                }}
                                                style={{ height: 38 }}

                                            >
                                                <MenuItem value={"Select"}>Select</MenuItem>
                                                <MenuItem value={"State Bank of India-549"}>State Bank of India-549</MenuItem>
                                                <MenuItem value={"HDFC Bank Limited"}>HDFC Bank Limited</MenuItem>
                                                <MenuItem value={"ICICI"}>ICICI</MenuItem>
                                                <MenuItem value={"ICICI Bank"}>ICICI Bank</MenuItem>
                                                <MenuItem value={"AXIS 1528"}>AXIS 1528</MenuItem>
                                                <MenuItem value={"BOB 0334"}>BOB 0334</MenuItem>
                                                <MenuItem value={"State Bank of India"}>State Bank of India</MenuItem>

                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    {/* <Grid item xl={3} lg={3} md={4} sm={6} xs={6}>
                                        <TextField
                                            id="outlined-basic"
                                            label="Reason"
                                            variant="outlined"
                                            fullWidth
                                            size='small'
                                        />

                                    </Grid> */}

                                    <Grid item xl={2} lg={2} md={4} sm={6} xs={6}>
                                        <FormControl fullWidth size='small' >
                                            <InputLabel id="demo-simple-select-label">Status</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={Data.status ? Data.status : "all"}
                                                label="Status"
                                                onChange={(e) => handleChange("status", e.target.value === "all" ? "" : e.target.value)}
                                                size='small'
                                                style={{ height: 38 }}

                                            >
                                                <MenuItem value={"P"}>Pending</MenuItem>
                                                <MenuItem value={"A"}>Approved</MenuItem>
                                                <MenuItem value={"X"}>Rejected</MenuItem>
                                                <MenuItem value={"all"}>All</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xl={2} lg={2} md={4} sm={6} xs={6}>
                                        <FormControl fullWidth size='small' >
                                            <InputLabel id="demo-simple-select-label">AI Status</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={Data.ai_status ? Data.ai_status : "all"}
                                                label="AI Status"
                                                onChange={(e) => handleChange("ai_status", e.target.value === "all" ? "" : e.target.value)}
                                                size='small'
                                                style={{ height: 38 }}

                                            >
                                                <MenuItem value={"pending"}>Pending</MenuItem>
                                                <MenuItem value={"approved"}>Approved</MenuItem>
                                                <MenuItem value={"rejected"}>Rejected</MenuItem>
                                                <MenuItem value={"all"}>All</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    {/* <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                                        <FormControl size='small'>
                                            <FormLabel id="demo-radio-buttons-group-label">Status</FormLabel>
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                defaultValue="All"
                                                name="radio-buttons-group"
                                                value={Data.status}
                                                onChange={(e) => handleChange("status", e.target.value)}
                                                row
                                                size='small'
                                            >
                                                <FormControlLabel value="P" control={<Radio />} label="Pending" />
                                                <FormControlLabel value="A" control={<Radio />} label="Approved" />
                                                <FormControlLabel value="X" control={<Radio />} label="Rejected" />
                                                <FormControlLabel value="" control={<Radio />} label="All" />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid> */}
                                    <Grid container mt={1} padding={0} pl={2} gap={2} justifyContent="center">
                                        <Grid item xl={1.5} lg={1.5} md={2} sm={12} xs={12}>
                                            <Button
                                                fullWidth
                                                variant='contained'
                                                color='secondary'
                                                size='small'
                                                style={{
                                                    padding: '1px'
                                                }}
                                                onClick={() => handleSearch()}
                                                autoFocus={false}
                                            >
                                                View
                                            </Button>
                                        </Grid>

                                        <Grid item xl={1.5} lg={1.5} md={2} sm={12} xs={12}>
                                            <Button
                                                fullWidth
                                                variant='outlined'
                                                color='secondary'
                                                size='small'
                                                style={{
                                                    padding: '1px'
                                                }}
                                                onClick={() => handleClear()}
                                                autoFocus={false}

                                            >
                                                clear
                                            </Button>
                                        </Grid>

                                        <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>
                                            <Button
                                                fullWidth
                                                variant='contained'
                                                color='secondary'
                                                size='small'
                                                style={{
                                                    padding: '1px'
                                                }}
                                                onClick={() => handleFileUploadDialogOpen()}
                                                autoFocus={false}

                                            >
                                                Upload Statement
                                            </Button>
                                        </Grid>

                                        <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>
                                            <Button
                                                fullWidth
                                                variant='outlined'
                                                color='secondary'
                                                size='small'
                                                style={{
                                                    padding: '1px'
                                                }}
                                                onClick={() => setViewUploadStatementStatus(true)}
                                                autoFocus={false}

                                            >
                                                Statement status
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                </AccordionDetails>
                            </Accordion>
                            
                        </Grid>
                        <Grid item xs={12} mt={1}>
                            <MainCard sx={{ height: '100%' }} mt={1}>
                                <TopupCheckerTable IsLoading={IsLoading} setIsLoading={setIsLoading} alert={handleAlertOpen} data={TopupData} filter={Data} handleSearch={handleSearch} />
                                <Stack direction="row">
                                    <Button variant='contained' color='secondary' size='small' onClick={() => downloadExcel()}>Export to excel</Button>
                                </Stack>
                            </MainCard>
                        </Grid>
                    </Grid>

            }

        </Grid>
    )
}

export default LimitTopupChecker